<ion-toolbar>
	@if (icon) {
		<ion-icon [name]="icon" size="large" slot="start"></ion-icon>
	}
	@if (src) {
		<ion-icon [src]="src" size="large" slot="start"></ion-icon>
	}
	<ion-title>{{ title | translate }}</ion-title>
	<ion-buttons slot="end">
		<ion-icon (click)="goBack()" name="close" size="large" src="../../../assets/topgolf/cross.svg"></ion-icon>
	</ion-buttons>
</ion-toolbar>
